<form
  class="bk-panel set-panel"
  [formGroup]="userProfileForm"
  (ngSubmit)="handleSubmit()"
  novalidate
  aria-labelledby="pf-title"
>
  <header class="set-panel__head">
    <div class="set-panel__intro">
      <h2 class="set-panel__title" id="pf-title">Your details</h2>
      <p class="set-panel__sub">How your name, photo and number appear to the rest of your team.</p>
    </div>
  </header>

  <!-- Photo: the tile opens the file picker; Change and Remove sit beside it -->
  <div class="pf__photo">
    <image-input
      label=""
      ariaLabel="Profile photo"
      [previewUrl]="profileImageUrl"
      [isLoading]="isUploadingImage || isDeletingImage"
      (imageSelected)="addProfileImage($event)"
      (imageDeleted)="deleteProfileImage()"
      roundedClass="rounded-full"
      sizeClass="size-20"
    />
  </div>

  <div class="set-grid">
    <input-field
      label="First name"
      [errorMessage]="submitted && userProfileForm.controls.firstName.invalid ? 'Enter your first name.' : ''"
    >
      <input
        class="input-style"
        type="text"
        autocomplete="given-name"
        placeholder="Your first name"
        formControlName="firstName"
      />
    </input-field>

    <input-field
      label="Last name"
      [errorMessage]="submitted && userProfileForm.controls.lastName.invalid ? 'Enter your last name.' : ''"
    >
      <input
        class="input-style"
        type="text"
        autocomplete="family-name"
        placeholder="Your last name"
        formControlName="lastName"
      />
    </input-field>

    <!-- The sign-in email: shown, not edited -->
    <div class="set-fact">
      <span class="set-fact__label" id="pf-email-label">Email address</span>
      <span class="set-fact__value">{{ email || '—' }}</span>
      <span class="set-fact__hint">You sign in with this address. An administrator can change it.</span>
    </div>

    <input-field
      label="Phone number"
      [errorMessage]="
        submitted && userProfileForm.controls.primaryContactNumber.invalid
          ? 'Enter a phone number your team can reach you on.'
          : ''
      "
    >
      <ngx-mat-input-tel
        formControlName="primaryContactNumber"
        [enablePlaceholder]="true"
        [preferredCountries]="['bw', 'za']"
        [enableSearch]="true"
      />
    </input-field>
  </div>

  @if (saveError) {
    <p class="set-alert pf__alert" role="alert">
      <span class="bk-sym" aria-hidden="true">error</span>
      <span>{{ saveError }}</span>
    </p>
  }

  <footer class="set-foot">
    <span class="set-foot__note" aria-live="polite">
      {{ hasChanges ? 'You have unsaved changes.' : 'Everything here is saved.' }}
    </span>
    @if (hasChanges) {
      <button type="button" class="bk-btn bk-btn--ghost" (click)="discardChanges()" [disabled]="isUpdatingProfile">
        Discard
      </button>
    }
    <customizable-button
      title="Save details"
      className="w-full"
      type="submit"
      [loading]="isUpdatingProfile"
      [disabled]="isUpdatingProfile || !hasChanges"
    />
  </footer>
</form>
